import { render, staticRenderFns } from "./MyComment.vue?vue&type=template&id=3ba317b4"
import script from "./MyComment.vue?vue&type=script&lang=ts"
export * from "./MyComment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports